import { DatePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IHotelInfo, IReservationData, PIMContactDetailsv2, PIMService } from 'core-lib';
import { MapComponent } from "../map/map.component";
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-confirmation-commondetails',
    imports: [TranslateModule, MapComponent, DatePipe],
    templateUrl: './confirmation-commondetails.component.html',
    styleUrl: './confirmation-commondetails.component.scss'
})
export class ConfirmationCommondetailsComponent implements OnInit, OnDestroy {
  @Input() reservation: IReservationData;
  @Input() isMultiRoomBooking: boolean = false;

  hotelInfo:IHotelInfo;
  contactDetails:PIMContactDetailsv2|null;
  subs:Subscription[] = [];

  constructor(private pimService: PIMService) {}

  ngOnInit() {
    this.hotelInfo = this.pimService.getHotelInfo(this.reservation.roomRate.room.hotelCode ?? this.reservation.hotelId);
    this.contactDetails = this.pimService.getContactDetails(this.reservation.roomRate.room.hotelCode ?? this.reservation.hotelId)
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe())
  }
}
